<template>
    <div :class="{section: true, barn: true, mobile: mobile()}">
        <img class="barnImg" src="@/assets/christmas/barn.svg">
        <img class="star" src="@/assets/christmas/star.svg">
        <div class="ground"></div>
        <p class="text">Da sie keinen Platz in den Herbergen bekommen, bringt Maria ihr Baby Jesus in einem Stall zur Welt.</p>
    </div>
</template>

<script>
    import Vue from 'vue'
    import Component from 'vue-class-component'
    import BasicComponent from "@/components/BasicComponent";

    @Component()
    export default class Barn extends BasicComponent {

        onActive() {

        }

        mounted() {
            this.register();
        }



    }
</script>
<style scoped lang="scss">
    @import "@/stylesheets/Christmas.scss";

    .barn {

        position: relative;
        background-color: $backgroundBlue;

        .barnImg {
            width: 50vw;
            max-height: 65vh;
            position: absolute;
            bottom: $groundHeight;
            right: 30%;
            transform: translateX(50%);
        }

        .star {
            height: 10vh;
            max-width: 50vw;
            min-height: 80px;
            position: absolute;
            top: 15vh;
            right: 15%;
            transform: translate(50%, -50%);
        }

        .text {
            text-align: left;
            width: 300px;
            max-width: 35vw;
            position: absolute;
            top: 25vh;
            left: 15%;
            font-weight: normal;
            font-size: 1.6em;
            color: black;
        }

    }

    .mobile {

        .barnImg {
            width: 90vw;
            right: 5vw;
            max-height: 40vh;
            transform: none;
            bottom: $mobileGroundHeight
        }

        .star {
            right: auto;
            top: 5vw;
            left: 5vw;
            transform: none;
        }

    }

</style>
